// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretLeftFilledSvg from "@ant-design/icons-svg/es/asn/CaretLeftFilled";
import AntdIcon from '../components/AntdIcon';

var CaretLeftFilled = function CaretLeftFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretLeftFilledSvg
  }));
};

CaretLeftFilled.displayName = 'CaretLeftFilled';
export default React.forwardRef(CaretLeftFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CaretLeftFilled.js
// module id = 729
// module chunks = 0